var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7406",
    "data-name": "Group 7406",
    transform: "translate(-390.785 -246.785)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(390.785 246.785)",
    fill: "#5cd79e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus",
    "data-name": "Icon feather-plus",
    transform: "translate(397.4 253.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4714",
    "data-name": "Path 4714",
    d: "M18,7.5V20.27",
    transform: "translate(-11.615 -7.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4715",
    "data-name": "Path 4715",
    d: "M7.5,18H20.27",
    transform: "translate(-7.5 -11.615)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGreen);
export default __webpack_public_path__ + "static/media/plus_green.9955e41a261f5dd2b0d26342b0ebd4de.svg";
export { ForwardRef as ReactComponent };